import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
  error: null,
};

// Async thunks
export const fetchSites = createAsyncThunk(
  'sites/fetchSites',
  async ({ namespace, params }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.getSites(namespace, params);
  },
);

export const fetchSiteById = createAsyncThunk(
  'sites/fetchSiteById',
  async ({ namespace, siteId }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.getSiteById(namespace, siteId);
  },
);

export const createSite = createAsyncThunk(
  'sites/createSite',
  async ({ site }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.createSite(site);
  },
);

export const updateSite = createAsyncThunk(
  'sites/updateSite',
  async ({ namespace, siteId, patch }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.updateSite(namespace, siteId, patch);
  },
);

export const deleteSite = createAsyncThunk(
  'sites/deleteSite',
  async ({ namespace, siteId }, { extra }) => {
    const { sitesApi } = extra;
    await sitesApi.deleteSite(namespace, siteId);
    return siteId;
  },
);

export const bookmarkSite = createAsyncThunk(
  'sites/bookmarkSite',
  async ({ siteId }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.bookmarkSite(siteId);
  },
);

export const shareSite = createAsyncThunk(
  'sites/shareSite',
  async ({ siteId }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.shareSite(siteId);
  },
);

export const mergeSites = createAsyncThunk(
  'sites/mergeSites',
  async ({ namespace, targetSiteId, sourceSiteIds }, { extra }) => {
    const { sitesApi } = extra;
    return sitesApi.mergeSites(namespace, targetSiteId, sourceSiteIds);
  },
);

const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSites.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchSiteById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSiteById.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(fetchSiteById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createSite.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createSite.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(createSite.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateSite.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateSite.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateSite.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteSite.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteSite.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteSite.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(bookmarkSite.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(bookmarkSite.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(bookmarkSite.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(shareSite.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(shareSite.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(shareSite.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(mergeSites.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(mergeSites.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(mergeSites.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default sitesSlice.reducer;
